export default function (H) {
  H.seriesType('lineargauge', 'column', null, {
    setVisible: function () {
      H.seriesTypes.column.prototype.setVisible.apply(this, arguments);
      if (this.markLine) {
        this.markLine[this.visible ? 'show' : 'hide']();
      }
    },
    drawPoints: function () {
      // Draw the Column like always
      H.seriesTypes.column.prototype.drawPoints.apply(this, arguments);

      // Add a Marker
      var series = this,
        chart = this.chart,
        inverted = chart.inverted,
        xAxis = this.xAxis,
        yAxis = this.yAxis,
        point = this.points[0], // we know there is only 1 point
        markLine = this.markLine,
        ani = markLine ? 'animate' : 'attr';

      // Hide column
      point.graphic.hide();

      if (!markLine) {
        var path = inverted
          ? ['M', 0, 0, 'L', -5, -5, 'L', 5, -5, 'L', 0, 0, 'L', 0, 0 + xAxis.len]
          : ['M', 0, 0, 'L', -5, -5, 'L', -5, 5, 'L', 0, 0, 'L', xAxis.len, 0];
        markLine = this.markLine = chart.renderer
          .path(path)
          .attr({
            fill: series.color,
            stroke: series.color,
            'stroke-width': 1,
          })
          .add();
      }
      markLine[ani]({
        translateX: inverted ? xAxis.left + yAxis.translate(point.y) : xAxis.left,
        translateY: inverted ? xAxis.top : yAxis.top + yAxis.len - yAxis.translate(point.y),
      });
    },
  });
}
